.markdown-text {
  & > :first-child {
    margin-block-start: 0;
  }
  & > :last-child {
    margin-block-end: 0;
  }
  ol,
  li {
    p {
      margin: 0;
    }
  }
  pre {
    padding: var(--mantine-spacing-xs);
    font-size: var(--mantine-font-size-sm);
    white-space: pre-wrap;
    background: alpha(var(--mantine-color-dark-6), 0.5);
    border-radius: var(--mantine-radius-xs);
  }
}
